export default __webpack_public_path__ + "static/media/room-polen-main.974d61ef.webp";